<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="77" height="77" viewBox="0 0 77 77">
        <g fill="none" fill-rule="evenodd">
            <circle cx="38.5" cy="38.5" r="38.5" fill="#828282"/>
            <path fill="#333" fill-rule="nonzero" d="M41.452 46.98L42.548 17h-7.16l1.096 29.98h4.968zM38.935 60C41.13 60 43 58.158 43 56.062c0-2.16-1.871-3.938-4.065-3.938-2.193 0-3.935 1.779-3.935 3.938C35 58.158 36.742 60 38.935 60z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'permission-grey'
}
</script>
